import type { SVGProps } from "react";

export default function RobotIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 10C5.63181 10 5.33333 10.2985 5.33333 10.6667C5.33333 11.0349 5.63181 11.3333 6 11.3333C6.36819 11.3333 6.66667 11.0349 6.66667 10.6667C6.66667 10.2985 6.36819 10 6 10Z"
        fill="#A5C9F6"
      />
      <path
        d="M9.33333 10.6667C9.33333 10.2985 9.6318 10 10 10C10.3682 10 10.6667 10.2985 10.6667 10.6667C10.6667 11.0349 10.3682 11.3333 10 11.3333C9.6318 11.3333 9.33333 11.0349 9.33333 10.6667Z"
        fill="#A5C9F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.666667C7.2636 0.666667 6.66667 1.26362 6.66667 2C6.66667 2.49352 6.9348 2.92442 7.33333 3.15496V4.66667H4C2.89543 4.66667 2 5.5621 2 6.66667V13.3333C2 14.4379 2.89543 15.3333 4 15.3333H12C13.1046 15.3333 14 14.4379 14 13.3333V6.66667C14 5.5621 13.1046 4.66667 12 4.66667H8.66667V3.15496C9.0652 2.92442 9.33333 2.49352 9.33333 2C9.33333 1.26362 8.7364 0.666667 8 0.666667ZM3.33333 6.66667C3.33333 6.29848 3.63181 6 4 6H4.92131L5.88612 7.9296C6.11197 8.38133 6.57366 8.66667 7.07867 8.66667H8.92133C9.42633 8.66667 9.888 8.38133 10.1139 7.9296L11.0787 6H12C12.3682 6 12.6667 6.29848 12.6667 6.66667V13.3333C12.6667 13.7015 12.3682 14 12 14H4C3.63181 14 3.33333 13.7015 3.33333 13.3333V6.66667ZM8.92133 7.33333L9.588 6H6.41202L7.07867 7.33333H8.92133Z"
        fill="#A5C9F6"
      />
      <path
        d="M0.666667 9.33333C0.298477 9.33333 0 9.6318 0 10V11.3333C0 11.7015 0.298477 12 0.666667 12C1.03485 12 1.33333 11.7015 1.33333 11.3333V10C1.33333 9.6318 1.03485 9.33333 0.666667 9.33333Z"
        fill="#A5C9F6"
      />
      <path
        d="M14.6667 10C14.6667 9.6318 14.9651 9.33333 15.3333 9.33333C15.7015 9.33333 16 9.6318 16 10V11.3333C16 11.7015 15.7015 12 15.3333 12C14.9651 12 14.6667 11.7015 14.6667 11.3333V10Z"
        fill="#A5C9F6"
      />
    </svg>
  );
}
